import React, { Component } from 'react';
import { MDBCard, MDBCardBody, MDBCardTitle } from 'mdbreact';
import "./CompanyInfo.css";

class CompanyInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      company: {},
      data: {},
      id: null,
      companyid: null,
      loading: false,
    };
  }

  componentDidMount() {
    this.setupData();
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.mode !== prevProps.mode ||
      this.props.id !== prevProps.id ||
      this.props.data !== prevProps.data
    ) {
      this.setupData();
    }
  }

  setupData = () => {
    if (this.props.data) {
      const data = this.props.data;
      this.setState({
        data: data,
        id: data.id || null,
        company: {},
        companyid: null,
        loading: false,
      });
      if (data.company) {
        this.setupCompanyData(data.company);
      }
    } else if (this.props.id) {
      this.setState({
        data: {},
        company: {},
        id: this.props.id,
        companyid: null,
        loading: true,
      });
      const organizationRef = this.props.db.collection('organizations').doc(this.props.id);
      organizationRef.get()
        .then(doc => {
          if (!doc.exists) {
            console.log('No such organization document!');
            this.setState({ loading: false });
          } else {
            if (doc.data().active) {
              const data = doc.data();
              data.id = doc.id;
              this.setState({
                data: data,
                id: data.id,
                loading: false,
              });
              if (data.company) {
                this.setupCompanyData(data.company);
              }
            } else {
              this.setState({ loading: false });
            }
          }
        })
        .catch(err => {
          console.log('Error getting organization document', err);
          this.setState({ loading: false });
        });
    } else {
      this.setState({
        data: {},
        company: {},
        id: null,
        companyid: null,
        loading: false,
      });
    }
  };

  setupCompanyData = (id) => {
    if (id && id !== this.state.companyid) {
      const companyRef = this.props.db.collection('company').doc(id);
      companyRef.get()
        .then(doc => {
          if (!doc.exists) {
            console.log('No such company document!');
          } else {
            if (doc.data().active) {
              const data = doc.data();
              data.id = doc.id;
              this.setState({
                company: data,
                companyid: data.id,
              });
            }
          }
        })
        .catch(err => {
          console.log('Error getting company document', err);
        });
    }
  };

  render() {
    const isPartnerMode = this.props.mode === 'buyerinfo' || this.props.mode === 'makerinfo' || this.props.mode === 'sellerinfo';

    if (isPartnerMode && !this.state.loading && !this.state.company.id && !this.state.data.name) {
      return (
        <>
          <h2>取引先情報</h2>
          取引先を選択してください。
        </>
      );
    }

    return (
      <>
        {this.props.mode === 'comapnyinfo' && <h2>企業情報</h2>}
        {isPartnerMode && <h2>取引先情報</h2>}

        <MDBCard>
          <MDBCardBody className="companyInfo">
            <MDBCardTitle>{this.state.company.name}</MDBCardTitle>
            <dl className="row">
              <dt className="col-sm-3">郵便番号</dt><dd className="col-sm-9">{this.state.company.zipcode}</dd>
              <dt className="col-sm-3">住所</dt><dd className="col-sm-9">{this.state.company.address}</dd>
              <dt className="col-sm-3">TEL</dt><dd className="col-sm-9">{this.state.company.TEL}</dd>
              <dt className="col-sm-3">FAX</dt><dd className="col-sm-9">{this.state.company.FAX}</dd>
            </dl>

            <MDBCard cascade>
              <MDBCardBody className="companyInfo">
                <MDBCardTitle>{this.state.data.name}</MDBCardTitle>
                <dl className="row">
                  <dt className="col-sm-3">郵便番号</dt><dd className="col-sm-9">{this.state.data.zipcode}</dd>
                  <dt className="col-sm-3">住所</dt><dd className="col-sm-9">{this.state.data.address}</dd>
                  <dt className="col-sm-3">TEL</dt><dd className="col-sm-9">{this.state.data.TEL}</dd>
                  <dt className="col-sm-3">FAX</dt><dd className="col-sm-9">{this.state.data.FAX}</dd>
                </dl>
              </MDBCardBody>
            </MDBCard>
          </MDBCardBody>
        </MDBCard>
      </>
    );
  }
}

export default CompanyInfo;